document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".lazy-video");

  if ("IntersectionObserver" in window) {
    let observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          if (!video.src) {
            video.src = video.dataset.src;
          }
          obs.unobserve(video);
        }
      });
    });

    videos.forEach(video => observer.observe(video));
  } else {
    // Fallback: load immediately
    videos.forEach(video => (video.src = video.dataset.src));
  }
});